import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type NumberAttributeOptions = BaseAttributeOptions;

// Attribute for non-integer numeric columns
export class NumberAttribute extends BaseAttribute {
  constructor(options: NumberAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'number';
  }

  getInitialValue(): unknown {
    return this.creationValue ? this.creationValue : 0;
  }
}
